var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":_vm.$t('ReportingWorkOrders_navbar_title')}}),_vm._v(" "),_c('DxWorkOrders',{attrs:{"back":_vm.back,"key-name":'reportingWorkOrders',"reporting":true,"planned-and-unplanned":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }